// FR content translations. Keyed `<type>.<id>.<field>`. From content-i18n workflow.
export const contentFr: Record<string, string> = {
  "card.trade-routes.name": "Routes commerciales",
  "card.trade-routes.desc": "+25% à toute la production de ressources.",
  "card.sharpened-tools.name": "Outils affûtés",
  "card.sharpened-tools.desc": "+35% de dégâts de récolte.",
  "card.wide-survey.name": "Vaste prospection",
  "card.wide-survey.desc": "+20% au rayon du cercle de récolte.",
  "card.guild-labor.name": "Main-d'œuvre de guilde",
  "card.guild-labor.desc": "+45% au taux de collecte automatique.",
  "card.efficient-masons.name": "Maçons efficaces",
  "card.efficient-masons.desc": "Bâtiments 15% moins chers.",
  "card.standing-army.name": "Armée permanente",
  "card.standing-army.desc": "+40% de défense et +10 de défense fixe.",
  "card.stone-walls.name": "Murs de pierre",
  "card.stone-walls.desc": "+22 de défense fixe.",
  "card.drilled-ranks.name": "Troupes aguerries",
  "card.drilled-ranks.desc": "+20% de défense et +8 de défense fixe.",
  "card.war-economy.name": "Économie de guerre",
  "card.war-economy.desc": "+50% de défense.",
  "card.watchtowers.name": "Tours de guet",
  "card.watchtowers.desc": "+15% de défense et +12% de production.",
  "card.scholars.name": "Érudits",
  "card.scholars.desc": "+45% à la production de savoir et à la tech.",
  "card.scientific-method.name": "Méthode scientifique",
  "card.scientific-method.desc": "+25% de savoir et +15% de production.",
  "card.enlightenment.name": "Lumières",
  "card.enlightenment.desc": "+30% de savoir et +12% de défense.",
  "card.mass-schooling.name": "Scolarisation de masse",
  "card.mass-schooling.desc": "+25% de savoir et +20% de collecte automatique.",
  "card.engineering.name": "Ingénierie",
  "card.engineering.desc": "+20% de production et bâtiments 10% moins chers.",
  "synergy.industrial-revolution.name": "Révolution industrielle",
  "synergy.industrial-revolution.desc": "Deux voies économiques s'unissent : +50% de production.",
  "synergy.fortress.name": "Forteresse",
  "synergy.fortress.desc": "Deux voies militaires s'unissent : +45% de défense et +25 fixe.",
  "synergy.great-library.name": "Grande bibliothèque",
  "synergy.great-library.desc": "Deux voies du savoir s'unissent : +60% de savoir et +25% de production.",
  "synergy.renaissance.name": "Renaissance",
  "synergy.renaissance.desc": "L'économie rencontre le savoir : +30% de production et +30% de savoir.",
  "synergy.war-machine.name": "Machine de guerre",
  "synergy.war-machine.desc": "L'économie rencontre le militaire : +20% de défense et +25% de production.",
  "synergy.enlightened-guard.name": "Garde éclairée",
  "synergy.enlightened-guard.desc": "Le savoir rencontre le militaire : +20% de défense et +30% de savoir.",
  "synergy.golden-age.name": "Âge d'or",
  "synergy.golden-age.desc": "Les trois voies en équilibre : +35% de production et de savoir, +20% de défense.",
  "skill.bountiful-start.name": "Départ abondant",
  "skill.bountiful-start.desc": "Commencez chaque partie avec plus de bois, de pierre et de minerai.",
  "skill.settlers.name": "Colons",
  "skill.settlers.desc": "Commencez chaque partie avec une population supplémentaire.",
  "skill.industrious.name": "Industrieux",
  "skill.industrious.desc": "+8% de production globale par niveau.",
  "skill.sharp-tools.name": "Outils tranchants",
  "skill.sharp-tools.desc": "+10% de dégâts de récolte par niveau.",
  "skill.wide-reach.name": "Large portée",
  "skill.wide-reach.desc": "+10% au rayon du cercle de récolte par niveau.",
  "skill.fortified.name": "Fortifié",
  "skill.fortified.desc": "+12% de défense de colonie par niveau.",
  "skill.swift-hands.name": "Mains agiles",
  "skill.swift-hands.desc": "+10% de collecte automatique par niveau.",
  "skill.long-memory.name": "Longue mémoire",
  "skill.long-memory.desc": "+1 heure de plafond hors ligne par niveau.",
  "skill.war-chest.name": "Trésor de guerre",
  "skill.war-chest.desc": "Commencez chaque partie avec du butin à dépenser en technologie.",
  "skill.archivist.name": "Archiviste",
  "skill.archivist.desc": "+10% de savoir et de défense tech par niveau.",
  "skill.master-mason.name": "Maître maçon",
  "skill.master-mason.desc": "Bâtiments 5% moins chers par niveau.",
  "tech.irrigation.name": "Irrigation",
  "tech.irrigation.desc": "+30% de production.",
  "tech.masonry.name": "Maçonnerie",
  "tech.masonry.desc": "Bâtiments 20% moins chers.",
  "tech.cartography.name": "Cartographie",
  "tech.cartography.desc": "+30% au rayon de récolte et +25% de dégâts de récolte.",
  "tech.logistics.name": "Logistique",
  "tech.logistics.desc": "+75% de collecte automatique.",
  "tech.conscription.name": "Conscription",
  "tech.conscription.desc": "+45% de défense.",
  "tech.bulwark.name": "Rempart",
  "tech.bulwark.desc": "Préparation au boss : +35% de défense et +40 de défense fixe.",
  "tech.surge.name": "Poussée de production",
  "tech.surge.desc": "+150% de production pendant 25 secondes. Réutilisable.",
  "artifact.double-harvest.name": "Faux jumelle",
  "artifact.double-harvest.desc": "Double le rendement de récolte et +50% de dégâts de récolte.",
  "artifact.aegis.name": "Cœur d'égide",
  "artifact.aegis.desc": "Double la défense de la colonie.",
  "artifact.resource-magnet.name": "Magnétite",
  "artifact.resource-magnet.desc": "+60% de production et +50% de collecte automatique.",
  "artifact.chronosphere.name": "Chronosphère",
  "artifact.chronosphere.desc": "+50% de temps en plus entre les vagues.",
  "artifact.philosophers-stone.name": "Pierre philosophale",
  "artifact.philosophers-stone.desc": "Double le savoir et +30% de production.",
  "building.house.name": "Maison",
  "building.house.desc": "Abrite les colons, augmentant la population et la main-d'œuvre.",
  "building.lumberCamp.name": "Camp de bûcherons",
  "building.lumberCamp.desc": "Abat le bois automatiquement.",
  "building.quarry.name": "Carrière",
  "building.quarry.desc": "Taille la pierre automatiquement.",
  "building.mine.name": "Mine",
  "building.mine.desc": "Extrait le minerai et renforce toute l'économie.",
  "building.barracks.name": "Caserne",
  "building.barracks.desc": "Forme des défenseurs, augmentant la défense de la colonie.",
  "building.school.name": "École",
  "building.school.desc": "Produit du savoir et fait progresser la technologie et la défense.",
  "resource.wood.name": "Bois",
  "resource.stone.name": "Pierre",
  "resource.ore.name": "Minerai",
  "resource.knowledge.name": "Savoir",
  // Calamities (v0.10)
  "calamity.quake.name": "Séisme",
  "calamity.quake.desc": "La terre s'est ouverte sous la colonie. Les réserves ont sombré dans les failles.",
  "calamity.flood.name": "Grande Crue",
  "calamity.flood.desc": "La rivière est montée dans la nuit et a pris ce qu'elle voulait.",
  "calamity.drought.name": "Sécheresse",
  "calamity.drought.desc": "Les puits baissent. Tout ralentit sous le ciel blanc et plat.",
  "calamity.plague.name": "Peste",
  "calamity.plague.desc": "Elle est arrivée avec une caravane et elle est restée. Les guérisseurs ont fait ce qu'ils ont pu.",
  "calamity.great-fire.name": "Grand Incendie",
  "calamity.great-fire.desc": "Cela a commencé dans un grenier. À l'aube, un quartier entier était en cendres.",
  "calamity.collapse.name": "L'Effondrement",
  "calamity.collapse.desc": "Le grand chantier a échoué. Les bâtisseurs se rejettent la faute.",
  "calamity.market-crash.name": "Krach du Marché",
  "calamity.market-crash.desc": "Le marché du butin a plié en une nuit. Fortunes de papier, cendres de papier.",
  "calamity.embargo.name": "Embargo Commercial",
  "calamity.embargo.desc": "Les routes sont fermées. Les caravanes attendent à des frontières qui n'étaient que des lignes sur une carte.",
  "calamity.unrest.name": "Troubles Civils",
  "calamity.unrest.desc": "La foule sur la place a cessé de scander et a commencé à prendre.",
  "calamity.exodus.name": "L'Exode",
  "calamity.exodus.desc": "Une caravane est partie avant le lever du soleil. Avec ses tentes, ses troupeaux et ses doutes.",
};
